import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "alerts-type",
  templateUrl: "./alerts-type.component.html",
  styleUrls: ["./alerts-type.component.scss"],
})
export class AlertsTypeComponent implements OnInit {
  @Input()
  gapsReportStatus: string;

  @Input()
  missingSubtitleReportAlertsStatus: string;

  @Input()
  missingAudiosReportAlertsStatus: string;

  @Input()
  emptyContractsReportAlertsStatus: string;

  @Output()
  onShowGapReportClick = new EventEmitter();

  @Output()
  onShowMissingSubtitleReportClicked = new EventEmitter();

  @Output()
  onShowMissingAudiosReportClicked = new EventEmitter();

  @Output()
  onShowEmptyContractsReportClicked = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  showGapReport() {
    this.onShowGapReportClick.emit();
  }

  showMissingSubtitleReport() {
    this.onShowMissingSubtitleReportClicked.emit();
  }

  showMissingAudiosReport() {
    this.onShowMissingAudiosReportClicked.emit();
  }

  showEmptyContractsReport() {
    this.onShowEmptyContractsReportClicked.emit();
  }
}
